let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hHyCx")).then(() => parcelRequire('iYJQV'));